<template lang="pug">
  .component-backoffice-console.row.column
    .row
      .column.large-3.p-0
        LoadingSpinner(v-if="!availableCommands")
        template(v-else)
          ul.accordion(data-accordion='', data-allow-all-closed='true', v-f-accordion="")
            li.accordion-item(data-accordion-item='' v-for="(commands,group) in availableCommands")
              a.accordion-title(href='#') {{group.toUpperCase()}}
              .accordion-content(data-tab-content='')
                .button.expand(v-for="(command, key) in commands", @click="handleButtonPress(command)") {{key.replace("kepler:","")}}
      .column.large-9.small-12
        pre.console(ref="console", )
          span(v-for="log in consoleLog", v-html="log")
        input.input(type="text", @keyup.enter="handleCommand", v-model="currentCommand", ref="input",:disabled="isRunning")
        h3(v-if="hasPound") REMEMBER TO REPLACE THE # WITH THE ENTITY NUMBER!
</template>

<script type="text/babel">

import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import LoadingSpinner from "../../components/structure/LoadingSpinner";

export default {
  name: "Console",
  components: {LoadingSpinner},
  data: function () {
    return {
      currentCommand: "",
      consoleLog: [
        "     []  ,----.___\n",
        "   __||_/___      '. Welcome back to 1991\n",
        "  /  ||    /|       )\n",
        " /   \"\"   / /       \\_.= Loading Playmoove Core Console....\n",
        "/________/ /\n",
        "|________|/         /!\\ WARNING: SOME COMMANDS CAN AFFECT SYSTEM PERFORMANCE /!\\\n"
      ],

      isRunning: false,
      availableCommands: null
    }
  },
  mounted() {
    var self = this
    KeplerBackofficeSdk.console.list(function (ok) {
      self.availableCommands = ok

      self.pushCommand("\nConsole loaded: please enter your command in the field below")

    }, function (error) {
      console.error(error)
    })
  },
  computed: {
    hasPound() {
      return this.currentCommand.includes("#")
    }
  },
  methods: {
    handleButtonPress(c) {
      this.currentCommand = c
      this.$refs.input.focus()
    },
    handleCommand(event) {
      this.runCommand(this.currentCommand)
    },
    pushCommand(command) {
      this.consoleLog.push(command + "\n")

      var e = this.$refs.console
      this.$nextTick(function () {
        e.scrollTop = e.scrollHeight
      })

    },
    runCommand(command) {
      if (!this.isRunning) {
        var self = this
        this.isRunning = true

        this.pushCommand('> ' + command)
        var c = this.currentCommand
        this.currentCommand = ''

        KeplerBackofficeSdk.console.run(c, (ok) => {
          self.pushCommand(ok.response)


          self.isRunning = false
        }, (error) => {
          self.pushCommand("# ERROR " + error.response.status + ":")
          self.pushCommand(JSON.stringify(error.response.data, null, 2))
          self.isRunning = false
        })
      }
    },
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">
.component-backoffice-console
  .console
    height: 600px
    background-color: #0a0a0a
    padding: 15px
    margin-bottom: 5px
    border-radius: 6px
    color: #3adb76
  .accordion
    background: #111
    border-radius: 6px
    overflow: hidden

  .accordion-content
    background: #333
    border: none
    font-family: monospace

  .accordion-title
    color: #3adb76
    border-color: #3adb76
    border-width: 1px 0 1px 0
    font-family: monospace

  .input
    border: #0a0a0a 1px solid
    font-family: monospace
    color: #3adb76
    background: #0a0a0a

  .button
    margin-right: 5px
    font-family: monospace
    background: #0a0a0a
    color: #3adb76

    &.expand
      width: 100%

</style>



// WEBPACK FOOTER //
// Console.vue?7179347a